import { render, staticRenderFns } from "./StudentPointDetail.vue?vue&type=template&id=af36795e&"
import script from "./StudentPointDetail.vue?vue&type=script&lang=js&"
export * from "./StudentPointDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports